import gql from 'graphql-tag';

export const EventItemFeaturesDetails = gql`
  fragment EventItemFeaturesDetails on EventItem {
    id
    features {
      free_waldograms_count
      video_guestbook_enabled
      slideshow_enabled
      custom_hashtag_enabled
      default_hashtag
      join_code_enabled
      qr_code_enabled
      marketing_prints_enabled
      white_label_marketing_prints_enabled
      photo_watermark_enabled
      hosting_duration
      max_storage
      max_galleries
      max_albums
      free_joins_enabled
      joins_enabled
    }
  }
`;
export const PurchasedEventItemFeaturesDetails = gql`
  fragment PurchasedEventItemFeaturesDetails on PurchasedEvent {
    id
    features {
      free_waldograms_count
      video_guestbook_enabled
      slideshow_enabled
      custom_hashtag_enabled
      default_hashtag
      join_code_enabled
      qr_code_enabled
      marketing_prints_enabled
      white_label_marketing_prints_enabled
      photo_watermark_enabled
      hosting_duration
      max_storage
      max_galleries
      max_albums
      free_joins_enabled
      members_view_enabled
      custom_tags_enabled
      face_highlights_enabled
      joins_enabled
    }
  }
`;
